import Vue from "vue";
import './plugins/vuetify'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import VueSession from 'vue-session'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import VueResource from "vue-resource"
import VTooltip from 'v-tooltip'
import Vuebar from 'vuebar';
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VueResource);
Vue.use(VueSession);
Vue.use(VTooltip);
Vue.use(Vuebar);
Vue.use(VueI18n);
Vue.use(BootstrapVue);
import en from './en.json'
import lt from './lt.json'

const defaultLocale = 'en'
const languages = {
  en: en,
  lt: lt,
}

const messages = Object.assign(languages)
Vue.config.productionTip = false


export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages,
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
